import React from 'react';
import {KeywordItem} from './KeywordItem';
import {KeywordFields} from './keywordItem.types';
import {
	ArrayValueProps,
	ArrayValues,
} from 'components/EntityList/ColumnRenderers';
import {EntityListColumn} from 'components/EntityList';
import {KeywordSuggestion} from 'types';

interface Props extends Partial<ArrayValueProps<KeywordFields>> {
	keywords: KeywordFields[];
	suggestions?: KeywordSuggestion[];
}

const renderKeyword = (keyword: KeywordFields): React.ReactElement => {
	return <KeywordItem keyword={keyword} />;
};

export function Keywords({
	keywords,
	suggestions,
	...other
}: Props): React.ReactElement {
	const flatSuggestions: KeywordFields[] = (suggestions || []).map(s => {
		return {
			id: s.keyword.id,
			name: s.keyword.name,
			vkos: [],
			vexClusters: [],
			descriptions: s.keyword.descriptions,
			isSuggestion: true,
		};
	});
	const uniqueSuggestions: KeywordFields[] = flatSuggestions.filter(
		(s: KeywordFields, index: number) => flatSuggestions.indexOf(s) === index,
	);
	const arrayElements = uniqueSuggestions.concat(keywords);
	return (
		<>
			<ArrayValues
				array={arrayElements}
				getValue={renderKeyword}
				limit={4}
				{...other}
			/>
		</>
	);
}

/**
 * Read this function's definition to know if your Details List is compatible
 * with this renderer.
 */
export const renderKeywordsCell: EntityListColumn['onRender'] = (
	item,
): React.ReactElement => {
	return <Keywords keywords={item.keywords} />;
};

export const renderMainKeywordsCell: EntityListColumn['onRender'] = (
	item,
): React.ReactElement => {
	return <Keywords keywords={item.mainKeywords} />;
};
